import { get, post, uploadfile } from '@/utils/request';

const base = '/api/v1/web_customer_service';
export const webCustomerServiceConversation = (params = {}) => get(`${base}/conversation`, params);
export const webCustomerServiceSend = (content) => post(`${base}/conversation/messages`, { content });
export const webCustomerServiceAIAction = (action) => post(`${base}/conversation/ai_action`, { action });
export const webCustomerServiceMediaURL = (id) => get(`${base}/messages/${id}/media`);
export const webCustomerServiceSendMedia = (kind, file) => {
  const data = new FormData();
  data.append('file', file);
  return uploadfile(`${base}/conversation/media/${kind}`, data);
};
